export const emptyFilters = {
  equipmentModel: [],
  instrumentAvailability: "",
  configurationBaseline: "",
  softwareVersion: "",
  belongingToGroup: "",
  systemStatus: "",
  location: "",
};
